import React from 'react';

export default function Loading() {

  return (
    <div className="is-loader"></div>
  );
};

